import {
  Button,
  SizableText,
  SmartLink,
  TextArea,
  YStack,
  colors,
  shadowStandard,
} from '@my/ui'
import { H3 } from 'app/components'
import { HeartHandshake } from '@tamagui/lucide-icons'
import { useState } from 'react'

export interface WriteForUsFormProps {
  submitting: boolean
  submitted: boolean
  onSubmit: (message: string) => void
}

export const WriteForUsForm = (props: WriteForUsFormProps) => {
  const [message, setMessage] = useState('')

  const renderForm = () => {
    return (
      <YStack gap="$2">
        <H3 fow="600">Write For Us!</H3>
        <SizableText color="$overlay11" fow="500">
          Tell us a little about yourself & what you’d like to write for Student Saviour
        </SizableText>
        <SizableText color="$overlay8" size="$1">
          Your Message
        </SizableText>
        <TextArea
          bw="$0.5"
          boc="$overlay9"
          bc="$white"
          color="$overlay9"
          multiline
          numberOfLines={10}
          placeholder="Your Message"
          value={message}
          onChangeText={setMessage}
        />
        {/* <ReCAPTCHA
          // TODO: this is a test value
          sitekey={'6LeIxAcTAAAAAJcZVRqyHh71UMIEGNQ_MXjiZKhI'}
          ref={captchaRef}
        /> */}
        <Button
          mt="$4"
          theme="primary"
          disabled={props.submitting}
          onPress={() => props.onSubmit(message)}
        >
          Submit
        </Button>
      </YStack>
    )
  }

  const renderSuccess = () => {
    return (
      <YStack gap="$3.5" jc="center" ai="center" py="$6">
        <YStack br={1000} p="$2.5" jc="center" ai="center" bg="$white" {...shadowStandard}>
          <HeartHandshake color={colors.primary} width={36} height={36} />
        </YStack>
        <YStack gap="$2" ai="center" jc="center">
          <SizableText textAlign="center" size="$6" color="$overlay12" fow="600">
            Thanks!
          </SizableText>
          <SizableText textAlign="center" size="$4" color="$overlay10" fow="500">
            We’ve received your message, one of our team will get back to you as soon as possible.
          </SizableText>
        </YStack>
        <SmartLink Component={Button} theme="primary" href="/life" width="50%">
          Go Back To Feed
        </SmartLink>
      </YStack>
    )
  }

  return (
    <YStack br="$3" flex={1} bc="$white" padding="$4" gap="$4" {...shadowStandard}>
      {props.submitted ? renderSuccess() : renderForm()}
    </YStack>
  )
}
